export enum CardType {
    FAMILIES = 'MultiProfile',
    FAMILY_DETAIL = 'MemberProfile',
    COLLECTION_DETAIL = 'CollectionDetail',
    COLLECTIONS = 'Collections'
}



// WEBPACK FOOTER //
// ./src/_components/GridDisplayView/CardTypes.ts